import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  SpanName,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { LtvPredictService } from '../../interfaces';
import { LtvPredictServiceDecorator } from './LtvPredictServiceDecorator';

export class LtvPredictServiceWithObservability extends LtvPredictServiceDecorator {
  constructor(
    ltvPredictService: LtvPredictService,
    private readonly observabilitySystem: ObservabilitySystem,
    private readonly funnelSettingsService: FunnelSettingsServiceInterface,
  ) {
    super(ltvPredictService);
  }

  async getLTVPredict(productName: string) {
    const span = this.observabilitySystem.startSpan(SpanName.GET_LTV_PREDICT);

    span.setAttributes({
      [ATTRS_ANALYTICS_FUNNEL_NAME]: this.funnelSettingsService.getFunnelName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: this.funnelSettingsService.getFunnelLocale(),
    });
    try {
      span.addEvent('Pending');
      const result = await super.getLTVPredict(productName);

      span.addEvent('Succeed');
      span.succeed();
      return result;
    } catch (err) {
      const error = normalizeError(err);

      span.addEvent('Failed');
      span.fail(error);

      throw err;
    }
  }
}
